<template>
  <div v-if="specialDiscountIds.length == 0" class="d-flex justify-content-center align-items-center h4">
    No special discount IDs found.
  </div>
  <div v-else-if="loading">
    Loading...
  </div>
  <b-container fluid v-else class="id-container">
    <b-row class="d-flex flex-column flex-lg-row">
      <div v-if="specialDiscountIds.length == 0" class="d-flex justify-content-center align-items-center h4">
        No special discount IDs found.
      </div>
      <div v-for="id in specialDiscountIds">

      </div>

      <div v-if="specialDiscountIds.length != 0" v-for="id in specialDiscountIds" sm="12" lg="6" class="pt-2" no-gutters
        style="row-gap:10px;">
        <b-card style="margin-right:10px;width:357px;" class="id-card ">
          <div class="px-2">
            <div class="d-flex justify-content-between align-items-center">
              <b style="font-family: MainFontRegular, sans-serif;font-size:16px;color:#2F3941;">{{ id.discount_type ==
                "senior" ? "Senior Citizen" : "PWD"}}</b>
              <b-dropdown v-if="id.is_approved == 1" variant="link" no-caret>
                <template slot="button-content">
                  <img src="@/assets/images/three-dots.svg" alt="actions">
                </template>
                <b-dropdown-item @click="openIdConfirmationModal(id.uuid, 'void')">Void</b-dropdown-item>
              </b-dropdown>
            </div>
            <div>
              <b-row no-gutters class="pt-2">
                <b-col sm="12" md="4">
                  <p class="label">ID Type</p>
                </b-col>
                <b-col class="info">
                  {{ id.customer_id_type == 'senior' ? 'Senior Citizen' : id.customer_id_type == 'pwd' ? 'PWD' :
                  id.customer_id_type
                  }}
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col sm="12" md="4">
                  <p class="label">Full Name</p>
                </b-col>
                <b-col class="info">
                  {{ id.customer_id_full_name }}
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col sm="12" md="4">
                  <p class="label">ID Number</p>
                </b-col>
                <b-col class="info">
                  {{ id.customer_id_number }}
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col sm="12" md="4">
                  <p class="label">Date Applied</p>
                </b-col>
                <b-col class="info">
                  {{ formatDate(id.created_at) }}
                </b-col>
              </b-row>
              <b-row no-gutters>
                <b-col>
                  <p class="label pb-2">Attachment/s</p>
                </b-col>
              </b-row>
              <b-row no-gutters>
                <div class="d-flex" style="gap: 10px;">
                  <div class="card-image" @click="openPreviewModal(id)">
                    <div
                      style="width: 75px; height: 75px; overflow: hidden; display: flex; justify-content: center; align-items: center;">
                      <img style="border-radius:10px; width: 100%; height: 100%; object-fit: cover;" v-bind="imageProps"
                        :src="id.customer_image_front" alt="id_front" @error="imageError($event)" />
                    </div>
                    <div class="image-overlay">
                      <div class="mr-4">
                        <img style="position: absolute; top: 25px; left: 25px; opacity: 0.7;"
                          src="@/assets/images/open-preview.svg" alt="preview-icon">
                      </div>
                    </div>
                  </div>
                </div>
              </b-row>
            </div>
            <template #footer>
              <div v-if="!id.is_approved" class="pt-3 px-2">
                <b-row no-gutters>
                  <b-col class="pt-2" style="margin-right:8px">
                    <b-button @click="openIdConfirmationModal(id.uuid, 'approve')" :disabled="loading" block
                      class="action-btn font-weight-normal" variant="primary">
                      Approve
                    </b-button>
                  </b-col>
                  <b-col class="pt-2">
                    <b-button @click="openIdConfirmationModal(id.uuid, 'reject')" :disabled="loading" block
                      class="action-btn btn-reject" variant="primary">
                      Reject
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>
        </b-card>
      </div>

    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      imageProps: { width: 80, height: 80 }
    };
  },
  computed: {
    ...mapState("customers", ["loading", "error", "specialDiscountIds"])
  },
  methods: {
    openPreviewModal(sdId) {
      this.$emit("open-preview-modal", sdId);
    },
    openIdConfirmationModal(uuid, action) {
      this.$emit("open-id-confirmation-modal", uuid, action);
    },
    formatDate: function (date) {
      return this.$moment(date).format("MMM D, YYYY");
    },
    imageError(event) {
      event.target.src = require("@/assets/images/Image_error_placeholder.svg");
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}

.card-image {
  position: relative;
}


.image-overlay {
  border-radius: 10px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 75px;
  width: 75px;
  opacity: 0;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}

.card-image:hover .image-overlay {
  opacity: 1;
}

.action-icon {
  width: 24px;
  height: 24px;
  background: transparent url("../../assets/images/three-dots.svg") no-repeat center / 22px;
  margin-right: 23px;
}

.action-btn {
  border-radius: 40px;
  min-height: 37px;
}

.label {
  color: #5d6679;
  padding-bottom: 2px;
  font-family: MainFontRegular, sans-serif;
  font-size: 14px;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
}

.info {
  color: #2f3941;
  padding-bottom: 2px;
  padding-left: 24px;
  font-family: MainFontRegular, sans-serif;
  font-size: 14px;
  word-break: break-all;

  @media (max-width: 1024px) {
    font-size: 12px;
  }
}

.id-dropdown {
  .dropdown-menu.show {
    align-items: center;
    padding: 4px;
    min-width: 80px !important;
    top: -30px !important;
    left: 25px !important;
  }

  .dropdown-item {
    width: 80px;
  }
}

.id-images {
  min-height: 75px;
}

.btn-reject {
  background-color: #49545c !important;
  border-color: #49545c !important;
}

.id-card {
  min-height: 100%;
  border-radius: 10px;

}

.id-container {
  padding-right: 140px !important;

  @media (max-width: 1024px) {
    padding-right: 0 !important;
  }
}
</style>
